import type { GlobalEventProperties } from "@v2/features/infra/analytics/events";

import * as React from "react";

import { useV1AnalyticsGetter } from "@v1/hooks/useV1AnalyticsGetter";
import { GlobalEventPropertiesGetterProvider } from "@v2/contexts/GlobalEventPropertiesContext";
import { useV2AnalyticsGetter } from "@v2/hooks/useV2AnalyticsGetter";

const FALLBACK_DEFAULTS: GlobalEventProperties = {
  storeUrl: undefined,
  workspaceId: null,
  projectId: null,
  elementId: null,
  elementName: null,
  elementType: null,
  elementVersion: null,
  chatId: null,
  pageId: null,
};

export const ScopedAnalyticsProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const getV2Props = useV2AnalyticsGetter();
  const getV1Props = useV1AnalyticsGetter();

  const mergedGetter = React.useCallback(
    (): GlobalEventProperties => ({
      ...FALLBACK_DEFAULTS,
      ...getV2Props(),
      ...getV1Props(),
    }),
    [getV2Props, getV1Props],
  );

  return (
    <GlobalEventPropertiesGetterProvider
      getGlobalEventProperties={mergedGetter}
    >
      {children}
    </GlobalEventPropertiesGetterProvider>
  );
};
